import React, { memo } from "react";
import { formatTimeFromUtc } from "utils/formatters";
import { ScoreDelta } from "components/ScoreDelta/ScoreDelta";
import { ScoreConfig } from "types/PatientRegion";
import { RegionInfoItem } from "./RegionInfoItem";

type Props = {
  score?: ScoreConfig;
  lastExamDate: string;
  weekNumber?: string | number;
  painScale?: string | number;
  classNames?: string;
  patientLastExamDate?: string | null;
};
export const RegionInfoItems = memo(
  ({
    score,
    lastExamDate,
    weekNumber,
    painScale,
    classNames,
    patientLastExamDate,
  }: Props) => {
    return (
      <div className={`flex space-x-4 ${classNames}`}>
        <div className="flex flex-col space-y-4">
          <RegionInfoItem title="Outcome Scores">
            <div className="flex space-x-1 items-baseline">
              <strong className="text-xl">{score?.currentValue || 0}</strong>
              {!!score?.delta && (
                <ScoreDelta delta={score?.delta} isBetter={score?.isBetter} />
              )}
            </div>
          </RegionInfoItem>
          <RegionInfoItem title="Last Exam">
            <strong className="text-xl">
              {formatTimeFromUtc(patientLastExamDate || lastExamDate) || "--"}
            </strong>
          </RegionInfoItem>
        </div>

        <div className="flex flex-col space-y-4">
          <RegionInfoItem title="Week">
            <strong className="text-xl">{weekNumber ?? '-'}</strong>
          </RegionInfoItem>
          <RegionInfoItem title="Vas (Pain Scale)">
            <strong className="text-xl">{painScale ?? '-'}</strong>
          </RegionInfoItem>
        </div>
      </div>
    );
  }
);
